import * as React from "react";
import classnames from "classnames";
import Input from "dt-design-system/es/input";
import PaxPlanInput from "./pax-plan-input";
import useStay from "../hooks/use-stay";
import usePaxPlan from "../hooks/use-pax-plan";
import * as Dates from "../services/dates";
import message from "./message";
import css from "./filters.module.css";
import Button from "dt-design-system/es/button";
import LiftIcon from "./lift-icon";

const LODGINGS = 0;
const SKI_PASSES = 1;

const links = {
  fr: {
    homePage:
      "https://reservation.alpedhuez.com/?hoteid=519&forceNewProvider=true",
    lodgings:
      "https://reservation.alpedhuez.com/hebergements/?hoteid=519&forceNewProvider=true",
    skiPasses: "https://skipass.alpedhuez.com/",
  },
  en: {
    homePage:
      "https://accommodation.alpedhuez.com/?hoteid=519&forceNewProvider=true",
    lodgings:
      "https://accommodation.alpedhuez.com/accommodation?hoteid=519&forceNewProvider=true",
    skiPasses: "https://skipass.alpedhuez.com/",
  },
};

const Filters = ({ lang }) => {
  const ref = React.useRef(null);
  const [currentTab, setCurrentTab] = React.useState(LODGINGS);
  const [stay, setStay] = useStay();
  const [paxPlan, setPaxPlan] = usePaxPlan();
  const [touched, setTouched] = React.useState({ from: false, to: false });

  const updateTab = (newTab) => {
    setCurrentTab(newTab);
  };

  const updateStay = (bound) => (newValue) => {
    setStay({ ...stay, [bound]: newValue });
    setTouched({ ...touched, [bound]: true });

    if (bound === "from" && Boolean(newValue)) {
      focusStayToField();
    }
    if (bound === "to" && Boolean(newValue)) {
      focusPaxPlanField();
    }
  };

  const focusStayToField = () => {
    const stayToField = ref.current?.querySelector("[data-to]");
    if (stayToField) {
      stayToField.click();
      scrollToFilters();
    }
  };

  const focusPaxPlanField = () => {
    const paxPlanField = ref.current?.querySelector("[data-pax]");
    if (paxPlanField) {
      paxPlanField.click();
      scrollToFilters();
    }
  };

  const scrollToFilters = () => {
    ref.current.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "center",
    });
  };

  const fixBrokenStay = React.useCallback(() => {
    const fromDate = stay?.from && new Date(stay.from);
    const toDate = stay?.to && new Date(stay.to);

    if ((fromDate && !toDate) || (fromDate && toDate && fromDate > toDate)) {
      const newToDate = fromDate;
      newToDate.setDate(newToDate.getDate() + 1);
      setStay({ ...stay, to: Dates.format(newToDate) });
    }
    if (toDate && !fromDate) {
      const newFromDate = toDate;
      newFromDate.setDate(newFromDate.getDate() - 1);
      setStay({ ...stay, from: Dates.format(newFromDate) });
    }
  }, [setStay, stay]);

  const defaultStayToFieldMonth = stay?.from
    ? new Date(stay.from).getMonth() + 1
    : undefined;

  const defaultStayToFieldYear = stay?.from
    ? new Date(stay.from).getFullYear()
    : undefined;

  const submitForm = (e) => {
    e.preventDefault();
    fixBrokenStay();
    const endpoint = links[lang].lodgings;
    console.log("oui");
    if (stay || paxPlan) {
      const paxPlanParam = paxPlan
        ? encodeURI(`&paxPlan=${JSON.stringify(paxPlan)}`)
        : "";
      const stayParams =
        stay?.from && stay?.to ? `?from=${stay.from}&to=${stay.to}` : "?";
      const endpointWithParams = endpoint.concat(stayParams, paxPlanParam);

      document.location.href = endpointWithParams;
    } else {
      document.location.href = endpoint;
    }
  };

  const noStayEndpoint = links[lang].homePage;
  const noStayUrl = paxPlan
    ? noStayEndpoint.concat(`?paxPlan=${JSON.stringify(paxPlan)}`)
    : noStayEndpoint;

  const classes = classnames(css.filters, {
    [css.filtersLodgings]: currentTab === LODGINGS,
    [css.filtersSkiPasses]: currentTab === SKI_PASSES,
  });

  return (
    <div ref={ref} className={classes}>
      <div className={css.inner}>
        <div className={css.tabs}>
          <button className={css.tab} onClick={() => updateTab(LODGINGS)}>
            {message(lang, "lodgings")}
          </button>
          <button className={css.tab} onClick={() => updateTab(SKI_PASSES)}>
            {message(lang, "ski-passes")}
          </button>
        </div>
        {currentTab === LODGINGS && (
          <>
            <div className={css.fields}>
              <Input
                type="date"
                className={css.filter}
                placeholder={message(lang, "arrival-placeholder")}
                value={stay?.from || ""}
                onValueChange={updateStay("from")}
                onMouseUp={scrollToFilters}
              />
              <Input
                type="date"
                className={css.filter}
                placeholder={message(lang, "departure-placeholder")}
                value={stay?.to || ""}
                hint={stay?.from}
                onValueChange={updateStay("to")}
                onMouseUp={scrollToFilters}
                min={stay?.from || undefined}
                defaultMonth={defaultStayToFieldMonth}
                defaultYear={defaultStayToFieldYear}
                data-to=""
              />
              <PaxPlanInput
                lang={lang}
                paxPlan={paxPlan}
                setPaxPlan={setPaxPlan}
                scrollToFilters={scrollToFilters}
              />
            </div>
            <a href={noStayUrl} className={css.link}>
              {message(lang, "no-stay")}
            </a>
          </>
        )}
        {currentTab === SKI_PASSES && (
          <div className={css.skiPasses}>
            {/* <div
              className={css.skiPassesMessage}
              dangerouslySetInnerHTML={{
                __html: message(lang, "book-ski-passes"),
              }}
            /> */}
            <Button
              tag="a"
              href={links[lang].skiPasses}
              className={css.skiPassesButton}
            >
              <LiftIcon />
              {message(lang, "book-ski-passes-button")}
            </Button>
          </div>
        )}
      </div>
      {currentTab === LODGINGS && (
        <button className={css.submit} onClick={submitForm}>
          {message(lang, "search")}
        </button>
      )}
    </div>
  );
};

export default Filters;
